import { updateTeamMember } from '@usehatchapp/javascript-sdk';
import { call } from 'utils/call';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';

import { SET_FRESH_ORGANIZATION_KEY } from '../../fresh';
import { ORGANIZATION_BOARDS, ORGANIZATION_TEAM } from '../../fresh/schema';
import { constants } from '../constants';

export const doUpdateTeamMember =
  ({ userId, organizationId, role, assignedBoardIDs = [] } = {}, callback) =>
  async ({ dispatch, request }) => {
    const {
      UPDATE_TEAM_MEMBER_FAILURE,
      UPDATE_TEAM_MEMBER_REQUEST,
      UPDATE_TEAM_MEMBER_SUCCESS,
    } = constants;

    try {
      // spot check incoming args
      if (
        !isCorrectHatchIdFormat(organizationId) ||
        !isCorrectHatchIdFormat(userId)
      ) {
        const e = new Error('Invalid argument format');
        call(callback)(e);
        return dispatch({ type: 'BAILOUT' });
      }

      // tell state we're updating user
      dispatch({ type: UPDATE_TEAM_MEMBER_REQUEST });

      // update user
      await request(updateTeamMember, {
        assignedBoardIDs,
        organizationId,
        role,
        userId,
      });

      // Trigger fetches for team and boards via reaction
      dispatch({
        actions: [
          {
            type: UPDATE_TEAM_MEMBER_SUCCESS,
          },
          {
            payload: {
              fresh: false,
              key: ORGANIZATION_BOARDS,
              organizationIDs: [organizationId],
            },
            type: SET_FRESH_ORGANIZATION_KEY,
          },
          {
            payload: {
              fresh: false,
              key: ORGANIZATION_TEAM,
              organizationIDs: [organizationId],
            },
            type: SET_FRESH_ORGANIZATION_KEY,
          },
        ],
        type: 'BATCH_ACTIONS',
      });

      // call the callback with no error and validated user response
      return call(callback)(null, { userId });
    } catch (error) {
      call(callback)(error);
      return dispatch({ error, type: UPDATE_TEAM_MEMBER_FAILURE });
    }
  };
